module.exports = __webpack_public_path__ + "img/open-microphone.6e128344.png";